import { modalAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(modalAnatomy.keys);

const baseStyle = definePartsStyle({
  overlay: {
    bg: 'rgba(0, 205, 109, 0.13)',
    backdropFilter: 'blur(3px)',
  },
});

const ModalStyles = defineMultiStyleConfig({ baseStyle });

export default ModalStyles;
